export const PAGE_NOTE = "Each brand has its own contract. You must sign a brand's contract before you can receive payouts from that brand.";
